module.exports = __webpack_public_path__ + "static/media/bmcc.ec2b795b.svg";